export const downloadBlob = (filename, blob) => {
    const downloadLink = document.createElement('a');
    document.body.appendChild(downloadLink);

    // Use special ms version if available to get it working on Edge.
    if (navigator.msSaveOrOpenBlob) {
        navigator.msSaveOrOpenBlob(blob, filename);
        return;
    }

    if ('download' in HTMLAnchorElement.prototype) {
        const url = window.URL.createObjectURL(blob);
        downloadLink.href = url;
        downloadLink.download = filename;
        downloadLink.type = blob.type;
        downloadLink.click();
        // remove the link after a timeout to prevent a crash on iOS 13 Safari
        window.setTimeout(() => {
            document.body.removeChild(downloadLink);
            window.URL.revokeObjectURL(url);
        }, 1000);
    } else {
        // iOS 12 Safari, open a new page and set href to data-uri
        let popup = window.open('', '_blank');
        const reader = new FileReader();
        reader.onloadend = function () {
            popup.location.href = reader.result;
            popup = null;
        };
        reader.readAsDataURL(blob);
    }

};

export const saveFile = async (url, blob) => {
    const examCard = sessionStorage.getItem('examCard');
    if (examCard === '') {
        return false;
    }
    const questionId = sessionStorage.getItem('qid');
    try {
        // Step 2: 准备 FormData 数据
        const formData = new FormData();
        formData.append('examCard', examCard); // 用户考试卡号
        formData.append('questionSource', 0); // 问题来源（示例：0）
        formData.append('questionID', questionId); // 问题 ID
        formData.append('questionType', 3); // 问题类型（示例：3）
        formData.append('sourceID', questionId); // 来源 ID（示例直接使用 questionId）
        formData.append('language', 'scratch'); // 文件语言（scratch）
        formData.append('scratchFile', blob, 'filename.sb3'); // 添加文件内容

        // 发送 POST 请求
        const response = await fetch(url, {
            method: 'POST',
            body: formData
        });

        // 检查响应是否成功
        if (!response.ok) {
            console.log('File uploaded fail');
            document.alert('文件上传失败！');
            return false;
        }

        // 解析 JSON 响应
        const data = await response.json();

        // 在这里，您可以根据需要处理响应数据
        // if (flag) {
        // eslint-disable-next-line no-negated-condition
        if (!data.success) {
            // eslint-disable-next-line no-alert
            alert(data.msg);
        } else {
            // eslint-disable-next-line no-alert
            // alert('保存成功！');
            const successEvent = {
                type: 'scSaving',
                detail: {message: 'scratch文件保存成功！', examCard, loading: false}
            };
            window.parent.postMessage(successEvent, '*'); // 通知父页面保存成功
            const startChangeEvent = {
                type: 'scChange',
                detail: {message: 'scratch文件已更新', examCard, fileState: false}
            };
            window.parent.postMessage(startChangeEvent, '*'); // 通知父页面开始保存
        }
        // }

        // 返回响应数据以供进一步处理
        // return data;
    } catch (error) {
        // 处理错误情况
        console.error('Error during file upload:', error);
        // Step 5: 通知父页面保存失败
        const errorEvent = {
            type: 'scSaving',
            detail: {message: 'scratch文件保存失败！', examCard, loading: false}
        };
        window.parent.postMessage(errorEvent, '*'); // 通知父页面保存失败
        throw error;
    }
};

export const upFile = async (url, blob, filename = 'filename.sb3') => {
    try {
        // 创建 FormData 对象并添加文件
        const formData = new FormData();
        formData.append('file', blob, filename);
        formData.append('userId', sessionStorage.getItem('userId') || '18712495260');

        // 发送 POST 请求
        const response = await fetch(url, {
            method: 'POST',
            body: formData
        });

        // 检查响应是否成功
        if (!response.ok) {
            console.log('File uploaded fail');
            document.alert('文件上传失败！');
            return false;
        }

        // 解析 JSON 响应
        const data = await response.json();

        // 在这里，您可以根据需要处理响应数据
        console.log('File uploaded successfully', data);

        // 返回响应数据以供进一步处理
        // return data;
    } catch (error) {
        // 处理错误情况
        console.error('Error during file upload:', error);
        // 可以选择抛出错误，以便在组件中捕获并处理
        throw error;
    }
};
